import React, { useContext, useEffect, useState } from "react";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import { Container, Row, Col } from "react-grid-system";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { MenuItem } from "@mui/material";
// Sayali160.jpg
// Sanjivani160.jpg
// Sakshi160.jpg
// Jiya160.jpg
// Parmarth160.jpg
// Leo160.jpg
// Krish160.jpg
// Aarush160.jpg
import explore_im1 from "../../assets/img/Sayali160.jpg";
import explore_im2 from "../../assets/img/Krish160.jpg";
import explore_im3 from "../../assets/img/Jiya160.jpg";
import explore_im4 from "../../assets/img/Parmarth160.jpg";
import explore_im5 from "../../assets/img/Leo160.jpg";
import explore_im6 from "../../assets/img/Sakshi160.jpg";
import explore_im7 from "../../assets/img/Divyanshu.jpg";
import explore_im8 from "../../assets/img/Sanjivani160.jpg";
import Autocomplete from "@mui/material/Autocomplete";
import Lottie from 'react-lottie-player'
// import Lottie from "lottie-react";
// import Lottie
import HomePageAnimation from '../../assets/img/Castingbell.json'


import list_logo from "../../assets/img/list_logo.png";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import arrowdown from "../../assets/img/arrowdown.svg";
import "./HomePage.css";
import { AuthContext } from "../../context/AuthContext";
import { Slide } from "./Slide";
import { Link, useHistory, useLocation } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CustomWindowScrollTo, getAge } from "../../utils/common";
import { Helmet } from "react-helmet";

// forms ---------
import * as yup from "yup";
import { useFormik } from "formik";
import { userService } from "../../services";
import { GlobalContext } from "./../../components/NameContext";

var body = document.body;
body.classList.add("Homepagereamovepadding");
const data = [
  {
    image: require("../../assets/img/user_slider1.png").default,
    text: "Sonya B.",
    text1:
      "Getting the role on Casting Bell was very easy. I just had to create a profile and offers came pouring in”.",
  },
  {
    image: require("../../assets/img/wallpaperflare1.jpg").default,
    text: "Emma Stone..",
    text1:
      "Getting the role on Casting Bell was very easy. I just had to create a profile and offers came pouring in”.",
  },
  {
    image: require("../../assets/img/wallpaperflare2.jpg").default,
    text: "Charlize Theron.",
    text1:
      "Getting the role on Casting Bell was very easy. I just had to create a profile and offers came pouring in”.",
  },
  {
    image: require("../../assets/img/img2.png").default,
    text: "Angelina Jolie.",
    text1:
      "Getting the role on Casting Bell was very easy. I just had to create a profile and offers came pouring in”.",
  },
  {
    image: require("../../assets/img/img1.png").default,
    text: "Emily Blunt.",
    text1:
      "Getting the role on Casting Bell was very easy. I just had to create a profile and offers came pouring in”.",
  },
];
function Pagination(props) {
  const { centerSlideDataIndex, updatePosition } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "5px",
        marginTop: 20,
      }}
    >
      {data.map((_, index) => {
        const isCenterSlide = props.centerSlideDataIndex === index;
        return (
          <div
            className="slider_bullet"
            onClick={() => {
              updatePosition(index);
            }}
            style={{
              height: 10,
              width: 10,
              borderRadius: "100%",
              background: isCenterSlide ? "#9B26B6" : "#EDEDED",
              cursor: "pointer",
            }}
          />
        );
      })}
    </div>
  );
}

const ageArray = [
  {
    value: 1,
    id: 1,
  },
  {
    value: 2,
    id: 2,
  },
  {
    value: 3,
    id: 3,
  },
  {
    value: 4,
    id: 4,
  },
  {
    value: 5,
    id: 5,
  },
  {
    value: 6,
    id: 6,
  },
  {
    value: 7,
    id: 7,
  },
  {
    value: 8,
    id: 8,
  },
  {
    value: 9,
    id: 9,
  },
  {
    value: 10,
    id: 10,
  },
  {
    value: 11,
    id: 11,
  },
  {
    value: 12,
    id: 12,
  },
  {
    value: 13,
    id: 13,
  },
  {
    value: 14,
    id: 14,
  },
  {
    value: 15,
    id: 15,
  },
  {
    value: 16,
    id: 16,
  },
  {
    value: 17,
    id: 17,
  },
  {
    value: 18,
    id: 18,
  },
  {
    value: 19,
    id: 19,
  },
  {
    value: 20,
    id: 20,
  },
  {
    value: 21,
    id: 21,
  },
  {
    value: 22,
    id: 22,
  },
  {
    value: 23,
    id: 23,
  },
  {
    value: 24,
    id: 24,
  },
  {
    value: 25,
    id: 25,
  },
  {
    value: 26,
    id: 26,
  },
  {
    value: 27,
    id: 27,
  },
  {
    value: 28,
    id: 28,
  },
  {
    value: 29,
    id: 29,
  },
  {
    value: 30,
    id: 30,
  },
  {
    value: 31,
    id: 31,
  },
  {
    value: 32,
    id: 32,
  },
  {
    value: 33,
    id: 33,
  },
  {
    value: 34,
    id: 34,
  },
  {
    value: 35,
    id: 35,
  },
  {
    value: 36,
    id: 36,
  },
  {
    value: 37,
    id: 37,
  },
  {
    value: 38,
    id: 38,
  },
  {
    value: 39,
    id: 39,
  },
  {
    value: 40,
    id: 40,
  },
  {
    value: 41,
    id: 41,
  },
  {
    value: 42,
    id: 42,
  },
  {
    value: 43,
    id: 43,
  },
  {
    value: 44,
    id: 44,
  },
  {
    value: 45,
    id: 45,
  },
  {
    value: 46,
    id: 46,
  },
  {
    value: 47,
    id: 47,
  },
  {
    value: 48,
    id: 48,
  },
  {
    value: 49,
    id: 49,
  },
  {
    value: 50,
    id: 50,
  },
  {
    value: 51,
    id: 51,
  },
  {
    value: 52,
    id: 52,
  },
  {
    value: 53,
    id: 53,
  },
  {
    value: 54,
    id: 54,
  },
  {
    value: 55,
    id: 55,
  },
  {
    value: 56,
    id: 56,
  },
  {
    value: 57,
    id: 57,
  },
  {
    value: 58,
    id: 58,
  },
  {
    value: 59,
    id: 59,
  },
  {
    value: 60,
    id: 60,
  },
  {
    value: 61,
    id: 61,
  },
  {
    value: 62,
    id: 62,
  },
  {
    value: 63,
    id: 63,
  },
  {
    value: 64,
    id: 64,
  },
  {
    value: 65,
    id: 65,
  },
  {
    value: 66,
    id: 66,
  },
  {
    value: 67,
    id: 67,
  },
  {
    value: 68,
    id: 68,
  },
  {
    value: 69,
    id: 69,
  },
  {
    value: 70,
    id: 70,
  },
  {
    value: 71,
    id: 71,
  },
  {
    value: 72,
    id: 72,
  },
  {
    value: 73,
    id: 73,
  },
  {
    value: 74,
    id: 74,
  },
  {
    value: 75,
    id: 75,
  },
  {
    value: 76,
    id: 76,
  },
  {
    value: 77,
    id: 77,
  },
  {
    value: 78,
    id: 78,
  },
  {
    value: 79,
    id: 79,
  },
  {
    value: 80,
    id: 80,
  },
  {
    value: 81,
    id: 81,
  },
  {
    value: 82,
    id: 82,
  },
  {
    value: 83,
    id: 83,
  },
  {
    value: 84,
    id: 84,
  },
  {
    value: 85,
    id: 85,
  },
  {
    value: 86,
    id: 86,
  },
  {
    value: 87,
    id: 87,
  },
  {
    value: 88,
    id: 88,
  },
  {
    value: 89,
    id: 89,
  },
  {
    value: 90,
    id: 90,
  },
  {
    value: 91,
    id: 91,
  },
  {
    value: 92,
    id: 92,
  },
  {
    value: 93,
    id: 93,
  },
  {
    value: 94,
    id: 94,
  },
  {
    value: 95,
    id: 95,
  },
  {
    value: 96,
    id: 96,
  },
  {
    value: 97,
    id: 97,
  },
  {
    value: 98,
    id: 98,
  },
  {
    value: 99,
    id: 99,
  },
  {
    value: 100,
    id: 100,
  },
];
const HomePage = () => {
  const { globalValue, setGlobalValue } = useContext(GlobalContext);
  const globalContextUpdate = () => {
    // Update the global value from this component
    setGlobalValue("");
  };
  useEffect(() => {
    globalContextUpdate();
  });

  const ref = React.useRef(StackedCarousel);
  const [centerSlideDataIndex, setCenterSlideDataIndex] = React.useState(0);
  const { dependencyData, GetSignUpDependency, isLoaded, isProfileFreezed } =
    useContext(AuthContext);
  const [cityList, setCityList] = useState(null);
  useEffect(() => {
    if (!dependencyData && isLoaded) {
      GetSignUpDependency();
    } else if (dependencyData && isLoaded) {
      setCityList(dependencyData?.city);
    }
  }, [dependencyData, isLoaded]);
  const onCenterSlideDataIndexChange = (newIndex) => {
    setCenterSlideDataIndex(newIndex);
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const updatePosition = (index) => {
    ref?.current?.swipeTo(index - centerSlideDataIndex);
  };

  useEffect(() => {
    setInterval(stuff, 100000);
  }, []);
  function subtractYears(numOfYears, date = new Date()) {
    date.setFullYear(date.getFullYear() - numOfYears);

    return date;
  }

  // Back to top button --------------------------
  const [visible, setVisible] = useState(false);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const checkLengthValidation = (e, field, setFieldValue) => {
    e.target.value.length <= 50
      ? setFieldValue(field, e.target.value)
      : e.preventDefault();
    e.stopPropagation();
  };
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);

  function stuff() {
    ref.current?.goNext();
  }

  var page1;
  var page2;
  var page3;

  function executeScrollpageone(node) {
    node.scrollIntoView({ behavior: "smooth", block: "top" });
  }
  const location = useLocation();
  const [age, setAge] = React.useState("");
  const [gender, setGender] = useState(null);
  const [talentGender, setTalentGender] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [talentEmail, setTalentEmail] = useState(null);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const formatDate = (date) => {
    return date ? dayjs(date).format("DD/MM/YYYY") : "";
  };

  useEffect(() => {
    if (location?.pathname && location.pathname === "/") {
      document.body.classList.add("no-scrollbar");
    }
    return () => {
      document.body.classList.remove("no-scrollbar");
    };
  }, []);

  // forms -----------------------------
  const history = useHistory();

  const HandleSaveFormValues = async ({
    age,
    city,
    date_of_birth,
    email,
    user_type,
    gender,
    name,
    phone_number,
  }) => {
    let payload = {
      age,
      city,
      date_of_birth,
      email,
      user_type,
      gender,
      name,
      phone_number,
    };
    return await userService.createLeads(payload).then((resp) => {
      return resp;
    });
  };
  const phoneRegExp = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/


  const talentValidationSchema = yup.object({
    gender: yup.number().required("Please select your gender").nullable(),
    age: yup.number().required("Please select your Age").nullable(),
    name: yup.string().required("Please Enter your Name").nullable(),
    phone_number: yup.string().required('We need this for notifications. No spam messages. Promise').matches(phoneRegExp, 'Please enter valid mobile number'),
    // city: yup.number().required("Mention your current location").nullable(),
    // email: yup
    // .string()
    // .email("Email is not Valid")
    // .required("Your email please").nullable(),
  });

  const talentFormik = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: talentValidationSchema,
    initialValues: {
      gender: null,
      age: null,
      name: null,
      phone_number: "",
    },
    onSubmit: ({ gender, name, age, phone_number }, { resetForm }) => {
      history.push({
        pathname: "/find-talents",
        state: {
          filterValue: {
            gender,
            name,
            age,
            phone_number,
          },
        },
      });
      window.scrollTo(0, 0);
      HandleSaveFormValues({
        age,
        phone_number,
        name,
        gender,
        user_type: "Recruiter",
      }).then((resp) => {
        resetForm();
      });
    },
  });
  const genderOptions = [
    { label: "Male", value: 1 },
    { label: "Female", value: 0 },
    { label: "Other", value: 2 },
  ];
  const findjobValidationSchema = yup.object({
    gender: yup.number().required("Please select your gender").nullable(),

    name: yup.string().required("Please Enter your Name").nullable(),
    email: yup
      .string()
      .email("Email is not Valid")
      .required("Your email please")
      .nullable(),
    date_of_birth: yup
      .date()
      .typeError("Please enter a vaild date of birth")
      .min(subtractYears(100), "Please enter a vaild date of birth")
      .max(new Date(), "Please enter a vaild date of birth")
      .required("When were you born?")
      .nullable()
      .default(undefined),
  });
  const findJobFormik = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: findjobValidationSchema,
    initialValues: {
      name: "",
      date_of_birth: null,
      gender: null,
      email: "",
    },
    onSubmit: ({ name, date_of_birth, gender, email }, { resetForm }) => {
      // console.log('findJobFormik.values.date_of_birth',name,date_of_birth,gender,email, )
      history.push({
        pathname: "/find-jobs",
        state: {
          filterValue: {
            name,
            date_of_birth,
            gender,
            email,
          },
        },
      });
      window.scrollTo(0, 0);
      HandleSaveFormValues({
        name,
        email,
        date_of_birth,
        gender,
        user_type: "Talent",
      }).then((resp) => {
        resetForm();
      });
    },
  });

  const dateCheck = (event) => {
    let d = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1");
    return d;
  };

  // const defaultOptions = {
  //   loop: true,
  //   autoplay: true,
  //   // animationData:HomePageAnimation,

  //   animationData: HomePageAnimation,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice"
  //   }
  // };

  const talentRedirectUrl = () => {
  window.open("/find-jobs", "_blank");
}

const recruiterRedirectUrl = () => {
  window.open("/find-talents", "_blank");
}

  return (
    <>
      <div>
        <Helmet htmlAttributes>
          <title>
            Casting Bell - India’s Most Trusted Online Casting Platform
          </title>
          <meta
            name="description"
            content={`Apply to over hundreds of casting calls, auditions and roles on Casting Bell. The most trusted platform for actors and models. Join for free and get cast today!`}
          />
          {/* <meta
            property="og:title"
            content={`Casting Bell - India’s Most Trusted Online Casting Platform`}
          />
          <meta
            property="og:description"
            content={`Apply to over hundreds of casting calls, auditions and roles on Casting Bell. The most trusted platform for actors and models. Join for free and get cast today!`}
          />
          <meta
            property="og:url"
            content={`${process.env.PUBLIC_URL}/castingbell.com`}
          />
          <meta
            property="og:image"
            content={`${process.env.PUBLIC_URL}/favicon.ico`}
          />
          <meta
            property="og:image:secure_url"
            content={`${process.env.PUBLIC_URL}/favicon.ico`}
          />
          <meta property="og:image:width" content="200" />
          <meta property="og:image:height" content="200" />
          <meta property="twitter:card" content="summary" />
          <meta
            property="twitter:image"
            content={`${process.env.PUBLIC_URL}/favicon.ico`}
          /> */}
        </Helmet>

        <section className="flex home_landing justify-center items-center">
          <div className="container mx-auto px-4">
            <div className="middle_content_txt middle_content_txthome">
              <Row style={{ justifyContent: "flex-end" }}>
                <Col md={6} sm={12} xs={12} lg={5}>
                  <div className="left_home_banner_contentnew1 hiddenwebpage">
                    <h1>Search. Shortlist. Contact. </h1>
                    <p>Go beyond your social circle and connect with talent <br />and opportunities - near and far. You’re about to have <br />the best online casting experience.</p>
                    <div className="flex flex-row w-full space-x-4 find_button find_button1">
                      <Button
                        onClick={recruiterRedirectUrl}
                      >
                        Find Talents
                      </Button>
                      <Button
                        className="sec_button"
                        onClick={talentRedirectUrl}
                      >
                        Find Jobs
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col md={6} sm={12} xs={12} lg={6}>
                  <div className="home_rightslideouter">
                    <div className="home_rightslidein">
                      <div className="card">
                        <div style={{ width: "100%", position: "relative" }} className="animations_New">
                          {/* <Lottie 
                          options={defaultOptions}
                          animationData={HomePageAnimation}

                          height={100}
                          width={100}
                           /> */}

                          <Lottie
                            loop
                            animationData={HomePageAnimation}
                            play
                            style={{}}
                          />
                          {/* <ResponsiveContainer
                            carouselRef={ref}
                            //render={(width, carouselRef) => {
                            render={(parentWidth, carouselRef) => {
                              return (
                                <StackedCarousel
                                  autoRotate={true}
                                  ref={carouselRef}
                                  slideComponent={Slide}
                                  // slideWidth={550}
                                  // carouselWidth={width}
                                  slideWidth={
                                    parentWidth < 800 ? parentWidth - 40 : 750
                                  }
                                  carouselWidth={parentWidth}
                                  data={data}
                                  maxVisibleSlide={5}
                                  //disableSwipe
                                  customScales={[1, 0.85, 0.7, 0.55]}
                                  transitionTime={400}
                                  onActiveSlideChange={
                                    onCenterSlideDataIndexChange
                                  }
                                />
                              );
                            }}
                          /> */}
                          {/* <div
                                       className="card-button left"
                                       size="small"
                                       onClick={() => ref.current?.goBack()}
                                    >
                                       <KeyboardArrowLeftIcon style={{ fontSize: 30 }} />
                                    </div>
                                    <div className="card-button right" size="small" onClick={stuff}>
                                       <KeyboardArrowRightIcon style={{ fontSize: 30 }} />
                                    </div> */}
                          {/* <Pagination
                            updatePosition={updatePosition}
                            centerSlideDataIndex={centerSlideDataIndex}
                          /> */}
                        </div>
                      </div>
                      {/* <link className='homeview_profile' href=''>View Profile</link> */}
                    </div>
                  </div>
                  <div className="left_home_banner_contentnew1 showinmobile">
                    <h1>Search. Shortlist. Contact. </h1>
                    <p>Go beyond your social circle and connect with talent <br />and opportunities - near and far. You’re about to have <br />the best online casting experience.</p>
                    <div className="flex flex-row w-full space-x-4 find_button find_button1">
                      <Button
                         onClick={() => history.push("/find-talents")}
                      >
                        Find Talents
                      </Button>
                      <Button
                        className="sec_button"
                        onClick={() => history.push("/find-jobs")}
                      >
                        Find Jobs
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </section>
        <section className="home_landingbottomscrollsection">
          <div className="container mx-auto px-4">
            <div className="home_landingbottomscroll">
              {/* <p>Recruiters on Casting Bell</p> */}
              <div className="home_bottomscrolltot">
                <div className="home_bottomscrollinner">
                  {/* <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div>
                        <div className='home_bottomscrolllist'>
                           <img src={list_logo} alt="" />
                        </div> */}
                </div>
              </div>
            </div>
            <div className="top_tobottom">
              <button
                onClick={() => CustomWindowScrollTo("Findtalent")}
                aria-label="arrowButton"
              >
                <img src={arrowdown} alt="" />
              </button>
            </div>
          </div>
        </section>
        <section className="talent_uniquerolesecmid talent_uniquerolesecmidtheme1">
          <div className="container mx-auto px-4">
            <div className="talent_left_uniquermiddle" id="Findtalent">
              <Row>
                <Col sm={12} md={6} xs={12} className="col_responser1">
                  <div className="left_uniquerole">
                    <h2>Talent for your unique roles</h2>
                    <span className="sp1">I’m looking to cast a</span>
                    <div className="home_formbx">
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">Gender</label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <Autocomplete
                              id="combo-box-demo"
                              className="home_formcontrol1"
                              disablePortal
                              fullWidth
                              value={genderOptions.find(
                                (each) =>
                                  each.value == talentFormik.values.gender
                              )}
                              onChange={(event, newValue) => {
                                talentFormik.setFieldValue(
                                  "gender",
                                  Number(newValue.value)
                                );
                              }}
                              options={genderOptions}
                              getOptionLabel={(option) => option.label}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select gender"
                                  variant="outlined"
                                  name="gender"
                                />
                              )}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {talentFormik.touched.gender &&
                                talentFormik.errors.gender}
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">Age</label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <Autocomplete
                              className="home_formcontrol1"
                              disablePortal
                              id="combo-box-demo"
                              options={ageArray}
                              fullWidth
                              getOptionLabel={(option) =>
                                option.value.toString()
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Choose age"
                                  name="age"
                                />
                              )}
                              value={ageArray.find(
                                (each) => each.value == talentFormik.values.age
                              )}
                              onChange={(event, newValue) => {
                                talentFormik.setFieldValue(
                                  "age",
                                  Number(newValue?.id)
                                );
                              }}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {talentFormik.touched.age &&
                                talentFormik.errors.age}
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          {/* <Col sm={4} md={4} xs={4}>
                                       <div className='form_labelhomebx'>
                                          <label className='form_labelhome'>City</label>
                                       </div>
                                    </Col>
                                    <Col sm={8} md={8} xs={8}>
                                        <Autocomplete
                                        className='home_formcontrol1'
                                          disablePortal
                                          id="combo-box-demo"
                                          options={cityList}
                                          fullWidth
                                          getOptionLabel={(option)=> option.city_name}
                                          renderInput={(params) => <TextField {...params} placeholder="Choose location" />}
                                          // onChange={(e,newValue) => setSelectedCity(newValue.id)}
                                          value={ageArray.find(each => each.id ==talentFormik.values.city)}
                                          onChange={(event, newValue) => {
                                          talentFormik.setFieldValue('city',Number(newValue?.id))
                                          }}
                                          />
                                          <p className='errText' style={{color:'#fff'}}>{talentFormik.touched.city && talentFormik.errors.city}</p>
                                    </Col> */}
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">
                                Your name
                              </label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <TextField
                              variant="standard"
                              fullWidth
                              size="medium"
                              className="home_formcontrol"
                              placeholder="Enter your full name"
                              value={
                                talentFormik.values.name
                              }
                              onChange={(e) => {
                                checkLengthValidation(
                                  e,
                                  "name",
                                  talentFormik.setFieldValue
                                );
                              }}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {talentFormik.touched.name &&
                                talentFormik.errors.name}
                            </p>
                          </Col>
                        </Row>
                      </div>

                      <div className="home_formbxlist">
                        <Row>
                          {/* <Col sm={4} md={4} xs={4}>
                                       <div className='form_labelhomebx'>
                                          <label className='form_labelhome'>Your Email</label>
                                       </div>
                                    </Col>
                                    <Col sm={8} md={8} xs={8}>
                                       <TextField
                                          variant="standard"
                                          fullWidth
                                          size="medium"
                                          className="home_formcontrol" 
                                          placeholder='Type your email' 
                                          onChange={(e) => talentFormik.setFieldValue('email',e.target.value)}
                                          value={talentFormik.values.email}
                                          />
                                           <p className='errText' style={{color:'#fff'}}>{talentFormik.touched.email && talentFormik.errors.email}</p>
                                    </Col> */}
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">
                                Phone number
                              </label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <TextField
                              variant="standard"
                              fullWidth
                              size="medium"
                              className="home_formcontrol"
                              name="mobile"
                              placeholder="Enter your 10-digit contact number"
                              value={talentFormik.values.phone_number}
                              onBlur={talentFormik.handleBlur}
                              onChange={(e) => {
                                if (e.target.value.length <= 10) {
                                  talentFormik.setFieldValue(
                                    "phone_number",
                                    dateCheck(e)
                                  );
                                } else {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }
                              }}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {talentFormik.touched.phone_number &&
                                talentFormik.errors.phone_number}
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4}></Col>
                          <Col sm={8}>
                            <p className="home_clickop">
                              By clicking below, you accept the{" "}
                              <Link
                                to="/view-cms/terms-and-condition"
                                target="_blank"
                                style={{
                                  color: "#fff",
                                  textDecoration: "none",
                                }}
                              >
                                Terms of Use
                              </Link>
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4}></Col>
                          <Col sm={8}>
                            <Button
                              noHover
                              className="find_btn"
                              variant="contained"
                              style={{ height: "fit-content" }}
                              onClick={talentFormik.handleSubmit}
                              disabled={isProfileFreezed}
                            >
                              Find Talents For Me
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  sm={12}
                  md={6}
                  xs={12}
                  className="col_responser2"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div className="home_exploreouter">
                    <div className="home_exploretop">
                      <h3>Explore options till you find the right fit</h3>
                      <p>Verified talents</p>
                    </div>
                    <div className="home_exploremid">
                      <Row>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im1} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/sayali1846`,
                                    "_blank"
                                  );
                                }}
                                class="view_profilelink"
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>Sayali, {getAge("1994-05-18T18:30:00.000Z")}y</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im2} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/krish6615`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>Krish, {getAge("2003-08-22T18:30:00.000Z")}y</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im3} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/jiya3333`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>Jiya, {getAge("1998-11-23T18:30:00.000Z")}y</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im4} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/parmarth2198`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>
                              Parmarth, {getAge("1990-11-13T18:30:00.000Z")}y
                            </p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im5} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/leo4225`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>Leo, {getAge("1994-08-15T18:30:00.000Z")}y</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im6} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/sakshi1329`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>Sakshi, {getAge("2001-10-24T18:30:00.000Z")}y</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im7} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/divyanshu7755`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>
                              Divyanshu, {getAge("1993-06-27T18:30:00.000Z")}y{" "}
                            </p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div className="list_explorebxtop">
                              <img src={explore_im8} alt="" />
                              <span className="wishlist_ico">
                                <FavoriteBorderIcon />
                              </span>
                              <Link
                                href="#"
                                class="view_profilelink"
                                onClick={() => {
                                  window.open(
                                    `https://www.castingbell.com/talent/sanjivani7953`,
                                    "_blank"
                                  );
                                }}
                              >
                                View Profile
                              </Link>
                            </div>
                            <p>
                              Sanjivani, {getAge("1997-02-26T18:30:00.000Z")}y
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="top_tobottom">
              <button
                onClick={() => CustomWindowScrollTo("Findjobs")}
                aria-label="arrowButton"
              >
                <img src={arrowdown} alt="" />
              </button>
            </div>
          </div>
        </section>
        <section
          ref={(node) => (page2 = node)}
          className="talent_uniquerolesecmid talent_uniquerolesecmidtheme"
        >
          <div className="container mx-auto px-4">
            <div
              className="talent_left_uniquermiddle talent_left_uniquermiddletheme"
              id="Findjobs"
            >
              <Row>
                <Col sm={12} md={6} xs={12} className="col_responser2">
                  <div className="home_exploreouter">
                    <div className="home_exploretop">
                      <h3>Top recruiters are looking for you</h3>
                      <p>Verified projects</p>
                    </div>
                    <div className="home_exploremid">
                      <Row>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-print-shoot-female-7905`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/01CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Print Shoot</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-digital-ad-female-5697`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/02CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Digital Ad</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-modeling-assignment-male-1114`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/03CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Modeling Assignment</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-print-shoot-male-3964`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/04CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Print Shoot</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-digital-ad-male-6143`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/07CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Digital Ad</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-print-shoot-female-6436`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/08CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Print Shoot</p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-print-shoot-male-7021`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/04CastingBell_CastingCall_home.jpg"
                                }
                                alt=""
                              />
                            </div>
                            <p>Print Shoot </p>
                          </div>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                          <div className="list_explorebx">
                            <div
                              className="list_explorebxtop  cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.castingbell.com/jobs/acting-modeling-jobs-mumbai-modeling-assignment-female-5939`,
                                  "_blank"
                                );
                              }}
                            >
                              <img
                                src={
                                  "/images/PosterList/07CastingBell_CastingCall.webp"
                                }
                                alt=""
                              />
                            </div>
                            <p>Modeling Assignment</p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={6} xs={12} className="col_responser1">
                  <div className="left_uniquerole rightchanges">
                    <h2>Showcase your talent </h2>
                    <span className="sp1">
                      Get personalized Casting call notifications
                    </span>
                    <div className="home_formbx">
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">Name</label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <TextField
                              variant="standard"
                              fullWidth
                              size="medium"
                              className="home_formcontrol"
                              placeholder="Enter your name"
                              value={findJobFormik.values.name}
                              onChange={(e) => {
                                findJobFormik.setFieldValue(
                                  "name",
                                  e.target.value
                                );
                              }}

                            // helperText={findJobFormik.touched.name && findJobFormik.errors.name}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {findJobFormik.touched.name &&
                                findJobFormik.errors.name}
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">Gender</label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <Autocomplete
                              className="home_formcontrol1"
                              disablePortal
                              size="medium"
                              id="combo-box-demo"
                              // options={[{id:0,value:'Female'},{id:1,value:'Male'},{id:2,value:'Neutral'},]}
                              value={genderOptions.find(
                                (each) =>
                                  each.value == findJobFormik.values.gender
                              )}
                              onChange={(event, newValue) => {
                                findJobFormik.setFieldValue(
                                  "gender",
                                  Number(newValue.value)
                                );
                              }}
                              options={genderOptions}
                              getOptionLabel={(option) => option.label}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select gender"
                                  variant="outlined"
                                  name="gender"
                                />
                              )}

                            // value={gender}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {findJobFormik.touched.gender &&
                                findJobFormik.errors.gender}
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">
                                Date of Birth
                              </label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <div className="form_labelhomebxcalendr">
                              {/* <TextField
                                          variant="standard"
                                          fullWidth
                                          className="home_formcontrol" placeholder='DD.MM.YYYY' /> */}
                              <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <DatePicker
                                  inputFormat="DD/MM/YYYY"
                                  renderInput={(props) => (
                                    <TextField {...props}
                                      inputProps={{
                                        ...props.inputProps,
                                        placeholder: "DD/MM/YYYY"
                                      }} />
                                  )}
                                  clearable
                                  className="home_formcontrol1 dateField"
                                  value={findJobFormik.values.date_of_birth}
                                  onChange={(value) => {
                                    if (value) {
                                      findJobFormik.setFieldValue(
                                        "date_of_birth",
                                        new Date(value)
                                      );
                                    } else {
                                      findJobFormik.setFieldValue(
                                        "date_of_birth",
                                        null
                                      );
                                    }
                                  }}
                                />
                                <p
                                  className="errText"
                                  style={{ color: "#fff" }}
                                >
                                  {findJobFormik.touched.date_of_birth &&
                                    findJobFormik.errors.date_of_birth}
                                </p>
                              </LocalizationProvider>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4} md={4} xs={4}>
                            <div className="form_labelhomebx">
                              <label className="form_labelhome">
                                Your email
                              </label>
                            </div>
                          </Col>
                          <Col sm={8} md={8} xs={8}>
                            <TextField
                              variant="standard"
                              fullWidth
                              size="medium"
                              className="home_formcontrol"
                              placeholder="Type your email"
                              onChange={(e) =>
                                findJobFormik.setFieldValue(
                                  "email",
                                  e.target.value
                                )
                              }
                              value={findJobFormik.values.email}
                            />
                            <p className="errText" style={{ color: "#fff" }}>
                              {findJobFormik.touched.email &&
                                findJobFormik.errors.email}
                            </p>
                          </Col>
                        </Row>
                      </div>

                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4}></Col>
                          <Col sm={8}>
                            <p className="home_clickop">
                              By clicking below, you accept the{" "}
                              <Link
                                to="/view-cms/terms-and-condition"
                                target="_blank"
                                style={{
                                  color: "#fff",
                                  textDecoration: "none",
                                }}
                              >
                                Terms of Use
                              </Link>
                            </p>
                          </Col>
                        </Row>
                      </div>

                      <div className="home_formbxlist">
                        <Row>
                          <Col sm={4}></Col>
                          <Col sm={8}>
                            <Button
                              noHover
                              className="find_btn"
                              variant="contained"
                              style={{ height: "fit-content" }}
                              onClick={findJobFormik.handleSubmit}
                              disabled={isProfileFreezed}
                            >
                              Find Jobs For Me
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </section>
        <span
          onClick={scrollToTop}
          className="circle"
          // ref={scrollTop}
          style={{ display: visible ? "inline" : "none" }}
        >
          <img src={arrowdown} alt="" />
        </span>
      </div>
    </>
  );
};

export default HomePage;
